import React, { memo, FC, useRef, useMemo } from 'react'

import { dotSize, lineHeight } from '@/constants/common'
import { ProgressBarProps } from '@/types/componentsPropsTypes'

import { StyledDot, StyledLine, StyledProgressBar } from './styles'
import { TimeLabels } from './TimeLabels'

const ProgressBarRaw: FC<ProgressBarProps> = ({
  currentTime = 0,
  duration = 0,
  dotColor = '#FFFFFF',
  lineColor = '#FFFFFF',
  lineBgColor = 'rgba(255,255,255,0.3)',
  currentTimeOnly = false,
}) => {
  const progressRef = useRef<HTMLDivElement>(null)

  const percentage = useMemo(
    () => ((currentTime / duration) * 100).toFixed(2),
    [currentTime, duration],
  )

  return (
    <StyledProgressBar ref={progressRef}>
      <StyledLine $height={lineHeight} $color={lineBgColor} $fullWidth />
      <StyledLine
        $height={lineHeight}
        $color={lineColor}
        $percentage={percentage}
      />
      <StyledDot $size={dotSize} $color={dotColor} $percentage={percentage} />
      <TimeLabels
        currentTime={currentTime}
        duration={duration}
        currentTimeOnly={currentTimeOnly}
      />
    </StyledProgressBar>
  )
}

export const ProgressBar = memo(ProgressBarRaw)
